import { Link } from 'react-router-dom';

function repairSeverity(original) {
  return (
    <Link to={`/serviceadministratorrepaircategories/edit/${original?.id}`}>
      {original?.repairCategory || ''}
    </Link>
  );
}

function repairSeverityCode(original) {
  return original?.repairCategoryCode || '';
}

function status(original) {
  return original?.status ? 'Active' : 'In-Active';
}

export { repairSeverity, repairSeverityCode, status };
